export function handleClick(e, $this) {
    e.preventDefault();
    $this.props.actions.router.push(e.target.getAttribute("href"));
}
